import Vue from 'vue';

const user = JSON.parse(sessionStorage.getItem('user')) || {};

const state = {
    isLoggedIn: (Object.getOwnPropertyNames(user).length !== 0),
    user: user || {},
};

const getters = {
    getLoginData(state) {
        return state.user || []
    }
};

const mutations = {
    SET_USER(state, user) {
        state.user = user;
    },
    SET_LOGGED_IN(state, status) {
        state.isLoggedIn = status
    }
};

const actions = {
    setUser({dispatch, commit}, userData) {

        Vue.prototype.$Api().defaults.headers.post['Content-Type'] = 'application/json';
        return Vue.prototype.$Api().post("/jwt-auth/v1/token", userData)
            .then(({data}) => {

                sessionStorage.setItem('user', JSON.stringify(data));
                commit('SET_USER', data);
                commit('SET_LOGGED_IN', true);

            }).catch((data) => {

                    const result = data.response.data;

                    dispatch('alerts/setAlert', result.code, {root: true});

                    sessionStorage.removeItem('user');

                    commit('SET_LOGGED_IN', false);
                    commit('SET_USER', {});

                }
            );

    },
    removeUser(context) {
        context.commit('SET_LOGGED_IN', false);
        context.commit('SET_USER', {});
        sessionStorage.removeItem('user');
    }
};

export const login = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};